import { render, staticRenderFns } from "./PlayerData.vue?vue&type=template&id=3ff5ba6d&"
import script from "./PlayerData.vue?vue&type=script&lang=js&"
export * from "./PlayerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports